import React, { useCallback } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { InputAdornment, Tooltip } from "@material-ui/core";
import Face from "@material-ui/icons/Face";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import DynamicInput from "components/DynamicInput/DynamicInput";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Snackbars from "components/Snackbar/Snackbar.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

// actions creators
import { setUsername } from "redux/ducks/login.js";
import { initResetPassword, clearResponse } from "redux/ducks/resetPassword.js";

const useStyles = makeStyles(styles);

const btnS = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-around",
};

export default function ResetPassword() {
  const dispatch = useDispatch();
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");

  React.useEffect(() => {
    setTimeout(function () {
      setCardAnimation("");
    }, 700);
  }, []);

  // selectors
  const username = useSelector((state) => state.login.username, shallowEqual);
  const { error, errorMessage } = useSelector((state) => state.resetPassword, shallowEqual);

  // calls
  const handleUsername = useCallback(
    (event) => dispatch(setUsername(event.target.value)),
    [dispatch]
  );

  const clearSnackbar = useCallback(() => {
    dispatch(clearResponse());
  }, []);

  const sendData = useCallback(
    (body) => {
      dispatch(initResetPassword(body));
    },
    [dispatch]
  );

  const handleSubmit = () => {
    if (!username) return;
    const body = { username };
    sendData(body);
  };

  const classes = useStyles();
  const history = useHistory();

  const handleGoBack = () => {
    clearSnackbar();
    history.goBack();
  };

  const isPristineUsername = () => username.length > 4 && false;

  return (
    <>
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={4}>
            <form>
              <Card login className={classes[cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter} gn4-login-header`}
                  color="info"
                >
                  <h4 className={classes.cardTitle}>Resetear contraseña</h4>
                </CardHeader>
                <CardBody>
                  <DynamicInput
                    className={classes.paddingFooterBottom}
                    labelText="Usuario"
                    color="info"
                    id="username"
                    formControlProps={{ fullWidth: true }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Face className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      type: "text",
                      value: username,
                      onChange: handleUsername,
                    }}
                  />
                </CardBody>
                <div style={btnS}>
                  <Button
                    className={classes.paddingFooterBottom}
                    color="tumblr"
                    simple
                    onClick={handleGoBack}
                  >
                    Regresar
                  </Button>
                  <Tooltip title={isPristineUsername() ? "Ingresa un usuario válido" : ""}>
                    <span>
                      <Button
                        className={classes.paddingFooterBottom}
                        color="info"
                        disabled={isPristineUsername()}
                        onClick={handleSubmit}
                      >
                        Reset
                      </Button>
                    </span>
                  </Tooltip>
                </div>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
      <Snackbars
        place="tr"
        color="danger"
        message={errorMessage}
        open={error}
        closeNotification={clearSnackbar}
        close
      />
    </>
  );
}
